<template>
	<section class="breadcrumbs">
		<div class="container">

			<slot name="breadcrumbs"></slot>

		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.breadcrumbs {
	display: block;
	position: relative;
	background: transparent;
	padding-top: 24px;
	width: 100%;

	.mixed_content & {
		margin-top: 0;
		margin-bottom: 56px;
	}

	.container {
		position: relative;
		z-index: 25;
		/* width: 100%; */

		#breadcrumbs {
			// position: relative;
			grid-column: span 12;
			/* min-height: 50px; */
			padding: 0;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}

			.breadcrumb_container {
				> span {
					grid-column: span 12;
					display: inline-flex;
					font: normal normal 500 14px/20px var(--primary-font-family);
					text-transform: uppercase;
					align-items: center;
					flex-wrap: wrap;

					span {
						display: inline-flex;
						font: normal normal 500 14px/20px var(--primary-font-family);
						text-transform: uppercase;
						align-items: flex-start;
						text-indent: 0;

						@media only screen and (max-width: 768px) {
							&:first-child {
								text-indent: -9999px;
							}

							&:first-child::before {
								content: '…';
								text-indent: 0;
							}
						}

						&.breadcrumb_last {
							color: var(--stone-grey);
							font: normal normal 500 14px/20px var(--primary-font-family);
							/* opacity: 0.7; */
						}

						a {
							font: normal normal 500 14px/20px var(--primary-font-family);
							text-transform: uppercase;
							color: var(--cool-charcoal);
							text-decoration: none;
							display: inline-flex;
							align-items: center;
						}

						strong {
							font: normal normal 500 14px/20px var(--primary-font-family);
							text-transform: uppercase;
							color: var(--cool-charcoal);
							text-decoration: none;
						}

						&.divider {
							margin: 0 15px;
							display: flex;
							justify-content: center;
							align-items: flex-start;

							&::before {
								// margin: 5px 10px 0 0;
								font: normal normal 500 11px/20px var(--primary-font-family);
								content: '|';
								color: var(--cool-charcoal);
							}
						}

						&:last-child {
							a {
								font: normal normal normal 14px/20px var(--primary-font-family);
								text-transform: uppercase;
							}
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/BreadCrumbs.vue